import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";
import {CustomSimpleProductListComponent} from "./custom-simple-product-list.component";
import {CustomProductItemModule} from "../custom-product-item/custom-product-item.module";
import {CustomSimpleProductItemModule} from "./custom-simple-product-item/custom-simple-product-item.module";

@NgModule({
  declarations: [CustomSimpleProductListComponent],
  exports: [CustomSimpleProductListComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SimpleProductListComponent: {
          component: CustomSimpleProductListComponent,
        },
      },
    } as CmsConfig),
    CustomProductItemModule,
    CustomSimpleProductItemModule,
  ]
})
export class CustomSimpleProductListModule {}
